/* 🤖 this file was generated by svg-to-ts */
export const matIconNotes: {
  name: 'notes';
  data: string;
} = {
  name: 'notes',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 11.01 3 11v2h18zM3 16h12v2H3zM21 6H3v2.01L21 8z"/></svg>`
};
